var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVersionLatest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 20,
    viewBox: "0 0 59 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 41307",
    d: "M59 16C59 18.2091 57.2091 20 55 20L12.3605 20C11.4783 20 10.6209 19.7084 9.92165 19.1705L2.12165 13.1705C0.0401032 11.5693 0.0401029 8.4307 2.12164 6.82951L9.92164 0.829508C10.6209 0.291636 11.4783 4.15448e-06 12.3605 4.07736e-06L55 3.49691e-07C57.2091 1.56562e-07 59 1.79086 59 4L59 6.875L59 10L59 13.75L59 16Z",
    fill: "#A0EE09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionLatest);
export default __webpack_public_path__ + "static/media/version-latest.bdcb0f6ff1cd18fc5389fb139bbe7ba3.svg";
export { ForwardRef as ReactComponent };